import React, { Component } from 'react';
import styled from '@emotion/styled';
import { Helmet } from "react-helmet";

import { Form, Field, FormSpy } from 'react-final-form';
import * as calculator from "calcdate";
import { Calendar, RadioButtonGroup, Select, FormField, Grid, Box, Button } from "grommet";
import LoginComponent from "../../components/Login";

// import { SecretClient } from "@azure/keyvault-secrets";

const IFrame = styled.iframe`
  width: 100%;
  height: 60vh;
`;

const calc = calculator.simpleCalculator;

const now = (new Date()).toISOString();

class RuntimeErrorPage extends Component {

  constructor() {
    super();
    this.state = {
      module: 'Events',
      secdim: 'eventAction',
    };
    this.setLogin = this.setLogin.bind(this);
    this.account = "analyticsdiag870";
    this.blob = "token";
    this.container = "analyticsconfig";
    this.appdetails = {
      clientId: "720f8c6b-406e-473c-8f48-103c54ccbbc1",
      authorityHost: "https://login.microsoftonline.com",
      tenantId: "c5f9cef3-6300-4cc2-90f6-be1b3f6e31d8"
    };
  }

  async setLogin() {

    const { BlobServiceClient } = await import(/* webpackChunkName: "@azure/storage-blob" */ '@azure/storage-blob');

    // Enter your storage account name
    const defaultAzureCredential = this.props.defaultAzureCredential;

    // key-vault currently doesn't work, because it doesn't support CORs :(
    // see https://feedback.azure.com/forums/906355-azure-key-vault/suggestions/34753195-enable-cors-for-key-vault
    // const client = new SecretClient("https://.....vault.azure.net/", defaultAzureCredential);
    // const latestSecret = await client.getSecret("....");
    // console.log("latestSecret", latestSecret);


    const blobServiceClient = new BlobServiceClient(
      `https://${this.account}.blob.core.windows.net`,
      defaultAzureCredential
    );
    const containerClient = blobServiceClient.getContainerClient(this.container);
    const blockBlobClient = containerClient.getBlockBlobClient(this.blob);
    const downloadBlockBlobResponse = await blockBlobClient.download(0);
    const blob = await downloadBlockBlobResponse.blobBody;
    const token = await blob.text();

    this.setState({ token });
  }

  componentDidMount() {
    if(!this.state.token) {
      this.setLogin();
    }
  }

  render() {

    return !this.state.token ? (<div>
      <p>Loading....</p>
    </div>) : (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Runtime error - MD Dashboard</title>
        </Helmet>
        <h1>Errors and Warnings</h1>
        <Form
          onSubmit={(a) => { console.log(a) }}
          validate={() => true}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Grid
                rows={['auto', 'flex']}
                columns={['1/3', '1/3', '1/3']}
                gap="small"
                areas={[
                  { name: 'c1', start: [0, 0], end: [0, 0] },
                  { name: 'c2', start: [1, 0], end: [1, 0] },
                  { name: 'c3', start: [2, 0], end: [2, 0] },
                  { name: 'main', start: [0, 1], end: [2, 1] },
                ]}
              >
                <Box gridArea="c1"><Field
                  name="date"
                  initialValue={now}
                  render={({ input, meta }) => (
                    <div>
                      <FormField label="Reporting Date">
                        <Calendar
                          size="small"
                          date={input.value}
                          bounds={[calc`now - 1y`.toISOString(), now]}
                          onSelect={input.onChange}
                        />
                        {meta.touched && meta.error && <span>{meta.error}</span>}
                      </FormField>
                    </div>
                  )}
                /></Box>

                <Box gridArea="c2"><Field
                  name="period"
                  initialValue="day"
                  render={({ input, meta }) => (
                    <div>
                      <FormField label="Reporting interval">
                        <RadioButtonGroup
                          {...input}
                          name="period"
                          options={['day', 'week']}
                          onChange={({ target: { value } }) => input.onChange(value)}
                        />
                        {meta.touched && meta.error && <span>{meta.error}</span>}
                      </FormField>
                    </div>
                  )}
                /></Box>

                <Box gridArea="c3"><Field
                  name="site"
                  initialValue="4"
                  render={({ input, meta }) => (
                    <div>
                      <FormField label="Reporting subject">
                        <Select
                          {...input}
                          value={input.value === "4" ? "test" : "production"}
                          options={["test", "production"]}
                          valueKey="value"
                          onChange={({ option }) => input.onChange(option === "test" ? "4" : "5")}
                        />
                        {meta.touched && meta.error && <span>{meta.error}</span>}
                      </FormField>
                    </div>
                  )}
                /></Box>
                <Box gridArea="main" id="widgetIframe">
                  <FormSpy subscription={{ values: true }}>
                    {({ values }) => (
                      <IFrame src={`https://analytics.masterdocs.com.au/index.php?module=Widgetize&action=iframe&secondaryDimension=${
                        this.state.secdim
                      }&disableLink=1&widget=1&moduleToWidgetize=${
                          this.state.module
                        }&actionToWidgetize=getCategory&idSite=${
                          values.site
                        }&period=${
                          values.period
                        }&date=${values.date.split("T")[0]}&widget=1&token_auth=${
                          this.state.token
                        }`} scrolling="yes" frameBorder="0" marginHeight="0" marginWidth="0">
                      </IFrame>
                    )}
                  </FormSpy>
                </Box>
              </Grid>
            </form>
          )}
        />
      </div>
    );
  }
}

export default () => {
  return <LoginComponent>{({ defaultAzureCredential }) => (<RuntimeErrorPage defaultAzureCredential={defaultAzureCredential} />)}</LoginComponent>
}
